/* @flow */
export default function safelyOpen(href: string) {
  // window.open() has an opener, which can't be removed in Safari. Instead,
  // create an anchor tag to add rel="noopenner noreferrer"
  let openTag = document.createElement("a");
  openTag.href = href;
  openTag.target = "_blank";
  openTag.rel = "noopener noreferrer";
  openTag.dispatchEvent(
    new MouseEvent(`click`, { bubbles: true, cancelable: true, view: window })
  );
}



// WEBPACK FOOTER //
// ./src/safelyOpen.js